// extracted by mini-css-extract-plugin
export default {"section":"Articles_section__iYEdv","wrapper":"Articles_wrapper__0U4Tb"};